/**
 * Context key that should only be provided if there is active brand data loaded in the store.
 * When this key has been provided (i.e. in useActiveBrand via inject), consumers can know that there
 * is no potential for the activeBrandId or activeBrand to be undefined in the store
 */
export const ACTIVE_BRAND_CONTEXT_KEY = 'active-brand'
